<template>
<div class="kne-modal-backdrop" @click.self="close()">
    <transition name="slide-fade">
        <div v-if="init" class="card kne-modal">
            <h3 v-if="title || closable" class="kne-title text-center py-2 px-3">
              <button v-if="closable" type="button" class="close" aria-label="Close" @click="close('x')">
                <span aria-hidden="true">&times;</span>
              </button>
              <span v-if="title">{{title}}</span>
            </h3>
            <div class="card-block px-0 pt-0">
              <slot></slot>
            </div>
        </div>
    </transition>
</div>
</template>
 
<script>
export default {
  data () {
    return {
      init: false
    }
  },
  props: {
    title: {
      type: String,
      required: false
    },
    closable: {
      type: Boolean,
      required: false
    },
    closableBackdrop: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    close: function (origin) {
      if (this.closableBackdrop) this.$emit('close-request')
      if (origin === 'x') this.$emit('close-request')
    },

    closeOnESC (e) {
        if (e.keyCode === 27) this.close('x')
    }
  },

  mounted () {
    this.init = true
    document.body.style.overflow = 'hidden'
    window.addEventListener('keyup', this.closeOnESC)
  },

  destroyed () {
    document.body.style.overflow = 'auto'
    window.removeEventListener('keyup', this.closeOnESC)
  }
}
</script>

<style scoped>
h3 {
  border-radius: 3px;
}
.card{
    border:none;
    /*min-height: 32rem;*/
}
.close {
  color: white;
  font-size: 2rem;
}
.kne-modal-backdrop{
    position: fixed;
    background-color: rgba(0,0,0,.5);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1002;  /* Modal backdrop is under GoogleMaps autocomplete (AddressBook add) */
}

.kne-modal{
  /*overflow:auto;*/
  top: 10%;
  left: 10%;
  max-width: 83%;
  max-height: 80%;
  padding: 0px;
  border-radius: 3px;
}

.card-block{
    overflow-y: auto;
    overflow-x: hidden;
}

.card-title>span{
    color: rgba(19, 19, 19, 0.6);
}

/* @media (max-width: 767px){
    .kne-modal{
        top: .5rem;
        max-height: 95%;
    }
} */

.slide-fade-enter-active, .slide-fade-leave-active{
    transition: all 500ms;
}

.slide-fade-enter, .slide-fade-leave-to{
    opacity: 0;
    transform: translateY(20px);
}
</style>
